export const Orders = {
  title: 'Pedidos em Curso',
  labelOrder: 'Pedido',
  labelPackage: 'Encomenda',
  labelUser: 'Cliente',
  resultSubtitle: 'Resultados',
  datePlaceholder: 'Seleccione Data de Inicio / Data de Fim',
  orderByChoiseUser1: 'Ordernar por: Data de Entrega',
  orderByChoiseUser2: 'Ordernar por: Código Postal',
  orderByChoise1: 'Data de Entrega',
  orderByChoise2: 'Código Postal',
  exportExcelFile: 'Exportar excel',
  noResults: 'Não foram encontrados resultados.',
  results: 'Resultados',
  labelNumOrder: 'Pedido',
  orderId: 'Nº',
  orderBo: 'Nº Pedido BO',
  supplierAvailableDate: 'Pedido de Recolha',
  promisseDate: 'Data Promessa',
  deliveryPeriodDate: 'Horário',
  collectionDate: 'Data Recolha',
  littleState: 'Estado',
  delivery: 'Entrega {date}',
  deliveryDate: 'Entrega a',
  alreadyDeliveryDate: 'Foi entregue a',
  numberVolumes: 'Nº de Volumes',
  labelWeight: 'Peso/Volume',
  type: 'Tipo',
  customerName: 'Nome',
  customerPhone: 'Contacto',
  postalCode: 'C. Postal',
  obs: 'Obs.',
  NumOrder: 'Pedido Nº {value}',
  previewDeliveryDate: 'Recolha Prevista {date}',
  clientDetails: 'Detalhes do Cliente',
  supplierDetails: 'Detalhes do Fornecedor',
  orderDate: 'Data Pedido',
  numVolumes: 'Nº de Volumes',
  numPallet: 'Nº de Paletes',
  equivalentNumberPallet: 'Nº de Paletes Equivalentes',
  normalEquivalentPallet: '= Nº Paletes Normais',
  volume: 'Volume (m<sup>3</sup>)',
  deliveryType: 'Tipo de Entrega',
  helper: 'Ajudante Extra?',
  installation: 'Montagem',
  userName: 'Nome do Cliente',
  supplierName: 'Nome do Fornecedor',
  email: 'E-mail',
  phone: 'Contacto Telefonico',
  address: 'Morada de Entrega',
  supplierAddress: 'Morada do Fornecedor',
  pCode: 'Código Postal',
  city: 'Localidade',
  store: 'Loja',
  collectPoint: 'Local de Recolha',
  plate: 'Matricula',
  collection: 'Recolha',
  collectionInformation: 'Informações sobre a Recolha',
  scheduleCollection: 'Recolha Agendada',
  scheduleInformation: 'Local de Recolha',
  MORNING: 'MANHÃ',
  AFTERNOON: 'TARDE',
  YES: 'Sim',
  NO: 'Não',
  observations: 'Observações',
  volumeWeight: '{weight}kg / {volume}m<sup>3</sup>',
  deliveryPeriod: 'Periodo de Entrega',
  tooltipOp1: 'Atribuir matrícula',
  tooltipOp2: 'Reagendar data de entrega',
  tooltipOp3: 'Agendar período de entrega',
  tooltipOp4: 'Marcar como entregue',
  tooltipOp5: 'Reportar incidência',
  tooltipOp6: 'Restaurar pedido',
  tooltipOp7: 'Pedido Recolhido',
  tooltipOp8: 'Reagendar data / período de entrega',
  CANCELED: 'Anulado',
  AWAITS_CONFIRMATION: 'Aguarda Confirmação do Fornecedor',
  TO_REJECT: 'Rejeitado pelo Fornecedor',
  IN_PREPARATION: 'Em Preparação Pelo Fornecedor',
  AWAITS_DISPATCH: 'Aguarda Expedição',
  ON_EXPEDITION: 'Em Expedição',
  DELIVERED: 'Entregue',
  COMPLETED: 'Concluído',
  volumeTotal: 'Volumes',
  palletTotal: 'Paletes',
  palletEquivalentNumber: 'Paletes Equivalentes'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/Orders.js